// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.enrollment-progress-stepper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0;
    list-style: none;
    position: relative;
    z-index: 1;
    color: var(--primary-color);
    width: 90%;
    margin: 0 auto;
}

.enrollment-progress-stepper .progress-line {
    position: absolute;
    top: 50%;
    left: 0;
    width: 50%;
    height: 2px;
    background-color: #ccc;
    z-index: 2;
}

.enrollment-progress-stepper .progress-line-segment {
    width: 100%;
    height: 5px;
    background-color: #ccc;
    z-index: 2;
}
.enrollment-progress-stepper .progress-line-segment.completed {
    background-color: var(--primary-color);
}
.enrollment-progress-stepper .progress-line-segment.completed {
    background-color: var(--primary-color);
}


.enrollment-progress-stepper .progress-line-segment.in-progress {
    background-image: linear-gradient(90deg, var(--primary-color), #ccc, #ccc);
}

.enrollment-progress-stepper .progress-step {
    z-index: 3;
    text-align: center;
    vertical-align: top;
    position: relative;
    height: 5em;
    padding: 0 0.5em;
    font-size: 0.8em;
}

.enrollment-progress-stepper .progress-step.hidden-labels {
    height: inherit;
}
.enrollment-progress-stepper .material-symbols-outlined {
    font-size: 32px;
    font-weight: 800;
    margin-bottom: 3px;
}
.enrollment-progress-stepper-tooltip {
    z-index: 1000;
}
`, "",{"version":3,"sources":["webpack://./src/EnrollmentProgressStepper/EnrollmentProgressStepper.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,2BAA2B;IAC3B,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,UAAU;IACV,WAAW;IACX,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,UAAU;AACd;AACA;IACI,sCAAsC;AAC1C;AACA;IACI,sCAAsC;AAC1C;;;AAGA;IACI,0EAA0E;AAC9E;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,aAAa;AACjB","sourcesContent":[".enrollment-progress-stepper {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0;\n    list-style: none;\n    position: relative;\n    z-index: 1;\n    color: var(--primary-color);\n    width: 90%;\n    margin: 0 auto;\n}\n\n.enrollment-progress-stepper .progress-line {\n    position: absolute;\n    top: 50%;\n    left: 0;\n    width: 50%;\n    height: 2px;\n    background-color: #ccc;\n    z-index: 2;\n}\n\n.enrollment-progress-stepper .progress-line-segment {\n    width: 100%;\n    height: 5px;\n    background-color: #ccc;\n    z-index: 2;\n}\n.enrollment-progress-stepper .progress-line-segment.completed {\n    background-color: var(--primary-color);\n}\n.enrollment-progress-stepper .progress-line-segment.completed {\n    background-color: var(--primary-color);\n}\n\n\n.enrollment-progress-stepper .progress-line-segment.in-progress {\n    background-image: linear-gradient(90deg, var(--primary-color), #ccc, #ccc);\n}\n\n.enrollment-progress-stepper .progress-step {\n    z-index: 3;\n    text-align: center;\n    vertical-align: top;\n    position: relative;\n    height: 5em;\n    padding: 0 0.5em;\n    font-size: 0.8em;\n}\n\n.enrollment-progress-stepper .progress-step.hidden-labels {\n    height: inherit;\n}\n.enrollment-progress-stepper .material-symbols-outlined {\n    font-size: 32px;\n    font-weight: 800;\n    margin-bottom: 3px;\n}\n.enrollment-progress-stepper-tooltip {\n    z-index: 1000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
